export const ONBOARDING_INDUSTRY_COOKIE_NAME = 'onboarding-industry';
export const ONBOARDING_SOLUTION_COOKIE_NAME = 'onboarding-solution';

export const FALLBACK_VALUES = {
    industry: 'Other',
    solution: 'Visitor Analysis',
};

export const CHAINS_ROUTE = '/chains/overview';
